export default class OwnerType {
  constructor() {
    this.id = null;
    this.name = null;
    this.icon = "mdi-account";
  }
}
